import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Footer from './Footer';
import HelpFeedback from './HelpFeedback';

function NotFound() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  const [autoRedirect, setAutoRedirect] = useState(true);

  useEffect(() => {
    if (autoRedirect && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (autoRedirect && countdown === 0) {
      navigate('/events');
    }
  }, [countdown, autoRedirect, navigate]);

  const handleCancelRedirect = () => {
    setAutoRedirect(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <HelpFeedback hasTopButton={true} />
      {/* Navigation Banner */}
      <nav style={{
        background: 'linear-gradient(135deg, #8B5FBF 0%, #6B46C1 50%, #2c2e96 100%)',
        padding: '1rem 2rem',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <h1 style={{ color: 'white', margin: 0, fontSize: '1.5rem' }}>OkGather</h1>
          </Link>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <Link to="/events" style={{ color: 'white', textDecoration: 'none', fontWeight: '500' }}>Events</Link>
            <Link to="/blog" style={{ color: 'white', textDecoration: 'none', fontWeight: '500' }}>Blog</Link>
            <Link to="/" style={{ color: 'white', textDecoration: 'none', fontWeight: '500' }}>Home</Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
        background: 'linear-gradient(to bottom, #f9fafb, #ffffff)'
      }}>
        <div style={{ textAlign: 'center', maxWidth: '600px' }}>
          {/* 404 Icon */}
          <div style={{
            fontSize: '6rem',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #8B5FBF 0%, #6B46C1 50%, #2c2e96 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem'
          }}>
            404
          </div>

          {/* Error Message */}
          <h1 style={{
            fontSize: '2rem',
            color: '#1f2937',
            marginBottom: '1rem',
            fontWeight: '600'
          }}>
            Page Not Found
          </h1>

          <p style={{
            fontSize: '1.125rem',
            color: '#6b7280',
            marginBottom: '2rem',
            lineHeight: '1.6'
          }}>
            Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
          </p>

          {/* Auto-redirect notice */}
          {autoRedirect && (
            <div style={{
              backgroundColor: '#f3f4f6',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '2rem'
            }}>
              <p style={{ margin: 0, color: '#4b5563', fontSize: '0.95rem' }}>
                Redirecting to Events page in <strong>{countdown}</strong> seconds...
              </p>
              <button
                onClick={handleCancelRedirect}
                style={{
                  marginTop: '0.5rem',
                  padding: '0.5rem 1rem',
                  backgroundColor: 'white',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                  color: '#374151'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#f9fafb'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
              >
                Cancel Auto-redirect
              </button>
            </div>
          )}

          {/* Navigation Options */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            alignItems: 'center'
          }}>
            <Link
              to="/events"
              style={{
                display: 'inline-block',
                padding: '0.75rem 2rem',
                background: 'linear-gradient(135deg, #8B5FBF 0%, #6B46C1 100%)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '1rem',
                boxShadow: '0 2px 4px rgba(139, 95, 191, 0.2)',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 8px rgba(139, 95, 191, 0.3)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(139, 95, 191, 0.2)';
              }}
            >
              Browse Events
            </Link>

            <div style={{ display: 'flex', gap: '1.5rem', marginTop: '0.5rem' }}>
              <Link
                to="/"
                style={{
                  color: '#8B5FBF',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '1rem'
                }}
              >
                Go to Homepage
              </Link>
              <Link
                to="/blog"
                style={{
                  color: '#8B5FBF',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '1rem'
                }}
              >
                Read Our Blog
              </Link>
            </div>
          </div>

          {/* Help Text */}
          <p style={{
            marginTop: '3rem',
            color: '#9ca3af',
            fontSize: '0.9rem'
          }}>
            Need help? Click the "Help / Feedback" button in the top right corner.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default NotFound;
